// extracted by mini-css-extract-plugin
module.exports =  {"MONTH":"alQc7X","month":"alQc7X","DAY":"pTrefL","day":"pTrefL","YEAR":"nHgaYp","year":"nHgaYp","fields":"QyCs8A","mobile":"GXT1Ot"};